"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SittingPose = void 0;
var BikeV2_1 = require("./BikeV2");
var Closedlegs1V2_1 = require("./Closedlegs1V2");
var Closedlegs2V2_1 = require("./Closedlegs2V2");
var CrossedlegsV2_1 = require("./CrossedlegsV2");
var Handsback1V2_1 = require("./Handsback1V2");
var Handsback2V2_1 = require("./Handsback2V2");
var Mid1V2_1 = require("./Mid1V2");
var Mid2V2_1 = require("./Mid2V2");
var Onelegup1V2_1 = require("./Onelegup1V2");
var Onelegup2V2_1 = require("./Onelegup2V2");
var WheelchairV2_1 = require("./WheelchairV2");
exports.SittingPose = {
    BikeV2: BikeV2_1.BikeV2,
    Closedlegs1V2: Closedlegs1V2_1.Closedlegs1V2,
    Closedlegs2V2: Closedlegs2V2_1.Closedlegs2V2,
    CrossedlegsV2: CrossedlegsV2_1.CrossedlegsV2,
    Handsback1V2: Handsback1V2_1.Handsback1V2,
    Handsback2V2: Handsback2V2_1.Handsback2V2,
    Mid1V2: Mid1V2_1.Mid1V2,
    Mid2V2: Mid2V2_1.Mid2V2,
    Onelegup1V2: Onelegup1V2_1.Onelegup1V2,
    Onelegup2V2: Onelegup2V2_1.Onelegup2V2,
    WheelchairV2: WheelchairV2_1.WheelchairV2
};
